import {inject, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {ApiUtilService} from './api-util.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  currentProject: any = {};

  apiUtilService = inject(ApiUtilService);

  constructor() {
  }

  /**
   * プロジェクト名を元にプロジェクトデータを取得
   * @param projectName
   */
  async getProjectByName(projectName: string): Promise<Observable<any>> {
    const body = {
      projectName: projectName,
    };
    return await this.apiUtilService.sendPostRequest('cms/getProjectEnvironment', body);
  }

  /**
   * プロジェクト一覧を取得
   */
  async listProjects(): Promise<Observable<any>> {
    return await this.apiUtilService.sendPostRequest('cms/getProjectList', {});
  }

  async updateProject(body: any = {}): Promise<Observable<any>> {
    return await this.apiUtilService.sendPostRequest('cms/updateProjectEnvironment', body);
  }
}
